/**
 * Maps vault documents to registered illustration contexts (Rule 2 — unDraw registry only).
 */
export function vaultDocumentIllustration(categoryId: string, subcategory?: string): string {
  const sub = (subcategory || '').toLowerCase();

  if (categoryId === 'photos' || sub.includes('photo') || sub.includes('signature') || sub.includes('thumb')) {
    return 'vault.photo';
  }
  if (categoryId === 'certificates' || sub.includes('certificate') || ['obc', 'ews', 'domicile', 'income'].some((k) => sub.includes(k))) {
    return 'vault.certificate';
  }
  if (categoryId === 'exam_documents' || sub.includes('admit') || sub.includes('score') || sub.includes('hall')) {
    return 'vault.exam';
  }
  if (categoryId === 'education' || sub.includes('graduation') || sub.includes('class') || sub.includes('ph.d') || sub.includes('diploma')) {
    return 'vault.education';
  }
  if (categoryId === 'identity' || ['aadhaar', 'pan', 'passport', 'license'].some((k) => sub.includes(k))) {
    return 'vault.identity';
  }
  if (categoryId === 'other' || sub.includes('resume') || sub.includes('experience')) {
    return 'vault.other';
  }

  return 'vault.default';
}
